import { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import './Interventions.css';
import withAuth from '../../components/withAuth';
import InterventionsFilters from '../../components/Interventions/InterventionsFilters'
import {
    loadInterventionModel, synchronizeWorkOrders, setFilteredAndSortedInterventions,
    getStartedWorkOrder
} from '../../redux/intervention/interventionActions'
import { cleanOldInterventions } from '../../redux/intervention/interventionEditionActions'
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon/Icon";
import FooterFixedOnScreen from '../Layout/FooterFixedOnScreen'
import { loadProductCategories } from '../../redux/product/productActions'
import { initializeDays } from '../../redux/day/dayEditionActions';
import { loadCurrentTimeSlot } from '../../redux/imputationInterventionRel/imputationInterventionRelActions';
import InterventionAlreadyInProgressModal from '../../components/Interventions/InterventionAlreadyInProgressModal'
import { getStateAccessor } from '../../lib/evaluateStringAsCodeHelper';
import { getCurrentFunctionName } from '../../performanceModeManager';
import InterventionsList from '../../components/Interventions/InterventionsList';
import { arraysAreSame } from '../../lib/array_helper';

class Interventions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            interventionAlreadyInProgressModalOpenned: false,
            interventionToPause: null,
        }

        this.props.loadInterventionModel();
        this.props.setFilteredAndSortedInterventions({ ...this.props.interventionsFilters });
        this.props.loadProductCategories();
        this.props.initializeDays(this.props.activeUser.id);
    }

    shouldComponentUpdate(nextProps, nextState) {
        let interventionToPauseChanged = this.state.interventionToPause !== nextState.interventionToPause;
        let interventionAlreadyInProgressModalOpennedChanged = this.state.interventionAlreadyInProgressModalOpenned !== nextState.interventionAlreadyInProgressModalOpenned
        let currentModeIdChanged = this.props.currentModeId !== nextProps.currentModeId
        let filteredAndSortedInterventionsChanged = !arraysAreSame(this.props.interventionsFilters.filteredAndSortedInterventions, nextProps.interventionsFilters.filteredAndSortedInterventions, true);

        return interventionToPauseChanged || interventionAlreadyInProgressModalOpennedChanged
            || currentModeIdChanged || filteredAndSortedInterventionsChanged
    }

    componentWillUnmount() {
        this.props.cleanOldInterventions({ ...this.props.interventionsFilters });
    }

    closeInterventionAlreadyInProgressModal() {
        this.setState({
            interventionAlreadyInProgressModalOpenned: false,
        })
    }

    onSyncClick() {
        this.props.synchronizeWorkOrders(this.props.activeUser, this.props.blocTypes,
            getStateAccessor(this.props), this.props.history, (interventions) => {
                this.props.setFilteredAndSortedInterventions({ ...this.props.interventionsFilters }, interventions);
            })
    }

    add() {
        getStartedWorkOrder().then(intervention => {
            if (intervention)
                this.props.loadCurrentTimeSlot(intervention.report_block_ids, this.props.blocTypes, this.props.activeUser).then(timeSlot => {
                    if (timeSlot) {
                        this.setState({
                            interventionToPause: intervention,
                            interventionAlreadyInProgressModalOpenned: true,
                        })
                    }
                })
            else {
                this.props.history.push("/interventions/createIntervention");
            }
        });
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <div className="container-with-footer">
                <InterventionsFilters interventionsFilters={this.props.interventionsFilters} />
                <InterventionsList globalContainer={this.props.globalStore.container} interventionsFilters={this.props.interventionsFilters} />
                <FooterFixedOnScreen>
                    <div className="row">
                        <div className="col-lg-1 col-md-2 col-sm-4 col-6">
                            <Fab onClick={this.onSyncClick.bind(this)}
                                className={"div-center"} >
                                <Icon>sync</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">Synchroniser</span>
                        </div>
                        <div className="offset-lg-10 col-lg-1 offset-md-8 col-md-2 offset-sm-4 col-sm-4 col-6">
                            <Fab id="btn-create-intervention" onClick={this.add.bind(this)} color="primary"
                                className={"div-center"} >
                                <Icon>add</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">Créer</span>
                        </div>
                    </div>
                </FooterFixedOnScreen>
                {this.state.interventionAlreadyInProgressModalOpenned &&
                    <InterventionAlreadyInProgressModal interventionInProgress={this.state.interventionToPause}
                        opened={this.state.interventionAlreadyInProgressModalOpenned} closeModal={this.closeInterventionAlreadyInProgressModal.bind(this)} />
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        currentModeId: state.interventions.currentModeId,
        blocTypes: state.interventions.blocTypes,
        loggedEmployee: state.loggedEmployee.loggedEmployee,
        fluidBottles: state.liquidBottles.myLiquidBottles,
        interventionsFilters: state.interventions,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadInterventionModel: () => dispatch(loadInterventionModel()),
        setFilteredAndSortedInterventions: (interventionsFilters, interventions) => dispatch(setFilteredAndSortedInterventions(interventionsFilters, interventions)),
        synchronizeWorkOrders: (user, blocTypes, stateAccessor, history, onSynchronized) => dispatch(synchronizeWorkOrders(user, blocTypes, stateAccessor, history, onSynchronized)),
        loadProductCategories: () => dispatch(loadProductCategories()),
        loadCurrentTimeSlot: (blocs, blocTypes, user) => dispatch(loadCurrentTimeSlot(blocs, blocTypes, user)),
        initializeDays: (userId) => dispatch(initializeDays(userId)),
        cleanOldInterventions: (interventionsFilters) => dispatch(cleanOldInterventions(interventionsFilters)),
    };
};

export default compose(withAuth, withRouter, connect(mapStateToProps, mapDispatchToProps))(Interventions);
